<template>
    <v-menu
        v-if="$store.getters.isAuthenticated"
        nudge-left="280"
        nudge-bottom="50"
    >
        <template v-slot:activator="{ on: menu, attrs }">
            <v-tooltip bottom>
                <template v-slot:activator="{ on: tooltip }">
                    <v-btn icon v-on="{ ...tooltip, ...menu }" v-bind="attrs">
                        <v-icon>settings</v-icon>
                    </v-btn>
                </template>
                <span>{{ $t("message.Settings") }}</span>
            </v-tooltip>
        </template>
        <v-card max-width="350px">
            <v-container>
                <v-row align="center">
                    <v-col cols="2" class="ml-2">
                        <v-icon large>accessibility_new</v-icon>
                    </v-col>
                    <v-col cols="3">
                        <v-tooltip
                            v-for="entry in languages"
                            :key="entry.title"
                            right
                        >
                            <template v-slot:activator="{ on: tooltip }">
                                <v-btn
                                    v-on="tooltip"
                                    @click="changeLocale(entry)"
                                    height="55px"
                                    class="mb-2"
                                    :class="selected(entry.language)"
                                    rounded
                                    text
                                >
                                    <v-img
                                        :src="
                                            require(`@/assets/flags/${entry.flag}.svg`)
                                        "
                                        style="width: 42px"
                                    />
                                </v-btn>
                            </template>
                            <span>{{ entry.title }}</span>
                        </v-tooltip>
                    </v-col>
                    <v-col cols="6">
                        <div class="font-weight-medium">
                            <v-list dense>
                                <v-list-item>
                                    {{ $store.getters.getLoggedUserName }}
                                </v-list-item>
                                <v-list-item>
                                    {{ $store.getters.getLoggedUserCompany }}
                                </v-list-item>
                                <v-list-item>
                                    Group:
                                    {{ $store.getters.getLoggedUserGroup }}
                                </v-list-item>
                            </v-list>
                        </div>
                    </v-col>
                    <v-col cols="2" class="ml-2">
                        <v-icon large>invert_colors</v-icon>
                    </v-col>
                    <v-col>
                        <v-switch
                            class="ml-4"
                            label="Dark Mode"
                            v-model="dark"
                            inset
                        />
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
    </v-menu>
</template>
<script>
export default {
    data: () => ({
        languages: [
            { flag: "nl", language: "nl", title: "Nederlands" },
            { flag: "gb", language: "en", title: "English" },
        ],
    }),
    computed: {
        selected() {
            return language => {
                if (this.$i18n.locale === language) {
                    return "selected-language";
                }
                return "not-selected-language";
            };
        },
        dark: {
            get() {
                return this.$vuetify.theme.dark;
            },
            set(val) {
                localStorage.setItem("dark", val);
                this.$vuetify.theme.dark = val;
            },
        },
    },
    methods: {
        changeLocale(entry) {
            localStorage.setItem("lang", entry.language);
            this.$i18n.locale = entry.language;
            this.$emit("changeLocale");
        },
    },
};
</script>
